module.exports = __webpack_public_path__ + "media/images/vector-right-d0fe8f11b005040d2b90c6e640443634.svg";